import * as moment from 'moment';
import validate from 'validate.js';

export const usaDateRegEx = /^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/;
export const unixDateRegEx = /^\d{4}[\-](0?[1-9]|1[012])[\-](0?[1-9]|[12][0-9]|3[01])$/;
export const numberRegEx = /^-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?$/;

//translation function
let t: any;

// Add new rules here
const checked = (value: boolean, options?: { message?: string }) => {
  if (!value) {
    return options!.message || t('must be checked');
  }
};

const phone = (value: string, options?: { message?: string }) => {
  if (value && value.length > 0) {
    const match = value.match(/\d/g);
    if (match) {
      if (!(match.length === 10)) {
        return options!.message || t('must be 10 digits');
      }
    }
  }
};

const password = (value: string, options?: { message?: string, allowBlank?: boolean }) => {
  const match = value && value.match(/./g);
  const allowBlank = options && options.allowBlank;
  let failed = false;

  if (!match && !allowBlank) failed = true;
  if (match && !(match.length >= 8 && match.length <= 128)) failed = true;

  if (failed) {
    return options!.message || t('must be between 8 and 128 characters long.');
  }
};

validate.extend(validate.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  parse(value: any, options?: any) {
    return moment.utc(value);
  },
  // Input is a unix timestamp
  format(value: any, options?: any) {
    const format = options.dateOnly ? 'MM/DD/YYYY' : 'MM/DD/YYYY hh:mm';
    return moment.utc(value).format(format);
  }
});

// Add any new rules to this object
const newValidators = {
  checked,
  phone,
  password,
};

export const initValidators = (translate: any) => {
  t = translate;

  validate.validators = {
    ...validate.validators,
    ...newValidators,
  };
};

export default newValidators;
